import classNames from 'classnames';
import { CheckCircle, Info, WarningCircle, X, XCircle } from 'phosphor-react';
import { useMemo, type JSX } from 'react';
import { ToastBar, toast as toaster, Toaster } from 'react-hot-toast';

export const useNotifications = () => {
  return useMemo(() => {
    const getNotificationFunction = (icon: JSX.Element, className: string) => (text: string | JSX.Element, duration = 5000) => toaster(
      text,
      {
        icon,
        duration,
        className: classNames('!max-w-full', className),
      },
    );

    return {
      success: getNotificationFunction(<CheckCircle />, '!bg-success-shade !text-contrast'),
      error: getNotificationFunction(<XCircle />, '!bg-danger !text-contrast'),
      warning: getNotificationFunction(<WarningCircle />, '!bg-warning'),
      info: getNotificationFunction(<Info />, '!bg-primary-light-shade'),
    };
  }, []);
};

export const Notifications = () => (
  <Toaster toastOptions={{}}>
    {toast => (
      <ToastBar toast={toast}>
        {({ icon, message }) => (<>
          <span className="flex-1">{icon}</span>
          {message}
          {toast.type !== 'loading' ? (
            <button
              title="Benachrichtigung schließen"
              type="button"
              onClick={() => toaster.dismiss(toast.id)}
            >
              <X size={18} />
              <span className="sr-only">Benachrichtigung schließen</span>
            </button>
          ) : null}</>
        )}
      </ToastBar>
    )}
  </Toaster>
);
